import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    standalone: true,
    name: 'shortenMiddle'
})

export class ShortenMiddlePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    limit: number,
    stripProtocol: boolean = false,
    stripWww: boolean = false
  ): string {
    if (typeof value !== 'string') return '';

    // Strip http/https
    if (stripProtocol) {
      value = value.replace(/^https?:\/\//, '');
    }

    // Strip www.
    if (stripWww) {
      value = value.replace(/^www\./, '');
    }

    if (value.length <= limit) return value;

    const ellipsis = '...';
    const charsToShow = limit - ellipsis.length;
    if (charsToShow <= 0) return ellipsis;

    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    const start = value.substring(0, frontChars);
    const end = value.substring(value.length - backChars);

    return `${start}${ellipsis}${end}`;
  }
}